import React from 'react';
import IndividualProvider from "./individual-context.jsx";
import IndividualForm from "./individual-form.jsx";

const IndividualIndex = () => {
    return (
        <IndividualProvider>
            <IndividualForm />
        </IndividualProvider>
    );
};

export default IndividualIndex;